"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureType = exports.signatureStates = exports.SignatureFactorsEnum = exports.SignatureEvents = exports.SignatureError = exports.SignatureStateEnum = void 0;
var SignatureStateEnum;
(function (SignatureStateEnum) {
    // Pending intiation of the signature process
    SignatureStateEnum["IDLE"] = "IDLE";
    // One or more authentication factors are required
    SignatureStateEnum["AUTHENTICATION_REQUIRED"] = "AUTHENTICATION_REQUIRED";
    // Signature process has finished successfully
    SignatureStateEnum["SIGNATURE_COMPLETED"] = "SIGNATURE_COMPLETED";
    // Signature process has been cancelled
    SignatureStateEnum["SIGNATURE_CANCELLED"] = "SIGNATURE_CANCELLED";
    // Signature process has reached a dead end
    SignatureStateEnum["SIGNATURE_FAILED"] = "SIGNATURE_FAILED";
    // An error has occurred executing an action
    SignatureStateEnum["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
})(SignatureStateEnum || (exports.SignatureStateEnum = SignatureStateEnum = {}));
var SignatureError;
(function (SignatureError) {
    SignatureError["GENERIC"] = "GENERIC";
    SignatureError["TIME_EXPIRED"] = "TIME_EXPIRED";
    SignatureError["CONSECUTIVE_ERRORS"] = "CONSECUTIVE_ERRORS";
    SignatureError["EXPIRED_SIGNATURE_KEY"] = "EXPIRED_SIGNATURE_KEY";
    SignatureError["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    SignatureError["CUSTOMER_DENIED"] = "CUSTOMER_DENIED";
})(SignatureError || (exports.SignatureError = SignatureError = {}));
var SignatureEvents;
(function (SignatureEvents) {
    SignatureEvents["IDLE"] = "IDLE";
    SignatureEvents["INITIATE"] = "INITIATE";
    SignatureEvents["VALIDATE"] = "VALIDATE";
    SignatureEvents["RESEND"] = "RESEND";
    SignatureEvents["CANCEL"] = "CANCEL";
})(SignatureEvents || (exports.SignatureEvents = SignatureEvents = {}));
var SignatureFactorsEnum;
(function (SignatureFactorsEnum) {
    SignatureFactorsEnum["OTP"] = "OTP";
    SignatureFactorsEnum["SIGNATURE_KEY"] = "SIGNATURE_KEY";
})(SignatureFactorsEnum || (exports.SignatureFactorsEnum = SignatureFactorsEnum = {}));
exports.signatureStates = {
    [SignatureStateEnum.IDLE]: {
        transitions: [
            SignatureStateEnum.AUTHENTICATION_REQUIRED,
            SignatureStateEnum.TECHNICAL_ERROR,
            SignatureStateEnum.SIGNATURE_FAILED,
            SignatureStateEnum.SIGNATURE_COMPLETED,
        ],
    },
    [SignatureStateEnum.AUTHENTICATION_REQUIRED]: {
        transitions: [
            SignatureStateEnum.AUTHENTICATION_REQUIRED,
            SignatureStateEnum.TECHNICAL_ERROR,
            SignatureStateEnum.SIGNATURE_FAILED,
            SignatureStateEnum.SIGNATURE_COMPLETED,
            SignatureStateEnum.SIGNATURE_CANCELLED,
        ],
    },
    [SignatureStateEnum.SIGNATURE_COMPLETED]: {
        transitions: [SignatureStateEnum.IDLE],
    },
    [SignatureStateEnum.SIGNATURE_CANCELLED]: {
        transitions: [SignatureStateEnum.IDLE, SignatureStateEnum.AUTHENTICATION_REQUIRED, SignatureStateEnum.TECHNICAL_ERROR],
    },
    [SignatureStateEnum.SIGNATURE_FAILED]: {
        transitions: [SignatureStateEnum.IDLE],
    },
    [SignatureStateEnum.TECHNICAL_ERROR]: {
        transitions: [SignatureStateEnum.IDLE],
    },
};
var SignatureType;
(function (SignatureType) {
    SignatureType["OTP"] = "OTP";
    SignatureType["OTP_LOGIN"] = "OTP_LOGIN";
    SignatureType["SIGNATURE_KEY"] = "SIGNATURE_KEY";
    SignatureType["NONE"] = "None";
})(SignatureType || (exports.SignatureType = SignatureType = {}));
//# sourceMappingURL=signature.types.js.map